import { render, staticRenderFns } from "./AppStartV2.vue?vue&type=template&id=78c2f2fd&"
import script from "./AppStartV2.vue?vue&type=script&lang=js&"
export * from "./AppStartV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports